<template>
  <v-navigation-drawer
    v-model="drawerStatus.flag"
    app
    clipped
    disable-resize-watcher
    hide-overlay
    :permanent="drawerStatus.permanent"
    @input="onStatus"
  >
    <div></div>
     <v-subheader style="background-color: #f5f5f5 !important; color: rgba(0,0,0,.87) !important; padding: 0px !important; margin-left:0px !important" v-if="showFlag" class="justify-center pl-0" inset app>
      <v-btn color="primary" @click="openmain">Main Menu</v-btn>
    </v-subheader>
    <v-timeline dense>
      <!-- <v-timeline-item small color="primary" v-if="getInterViewStatus == 1">
        <v-list>
          <v-list-item link @click="$router.push('/' + siteID + '/user/' + mortgageApplicationID + '/start')">{{
            $t("labels.Interview")
          }}</v-list-item>
        </v-list>
      </v-timeline-item> -->
      <!-- <v-timeline-item v-if="getInterViewStatus == 2" small :icon="'far fa-check-circle'" color="green" icon-color="white" :fill-dot="true">
        <v-list>
          <v-list-item link @click="$router.push('/' + siteID + '/user/' + mortgageApplicationID + '/start')">{{
            $t("labels.Interview")
          }}</v-list-item>
        </v-list>
      </v-timeline-item> -->

      <v-timeline-item small color="grey lighten-1" v-if="getApplicantStatus == 0 || app.MainApplicantID == 0">
        <v-list>
          <v-list-item link disabled>{{ $t("labels.Applicant") }}</v-list-item>
        </v-list>
      </v-timeline-item>

      <v-timeline-item v-if="getApplicantStatus == 1 && app.MainApplicantID != 0" small color="primary">
        <v-list>
          <v-list-item
            link
            @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + app.MainApplicantID + '/identification')"
            >{{ $t("labels.Applicant") }}</v-list-item
          >
        </v-list>
      </v-timeline-item>

      <v-timeline-item v-if="getApplicantStatus == 2 && app.MainApplicantID != 0" small :icon="'far fa-check-circle'" color="green" icon-color="white" :fill-dot="true">
        <v-list>
          <v-list-item
            link
            @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + app.MainApplicantID + '/identification')"
            >{{ $t("labels.Applicant") }}</v-list-item
          >
        </v-list>
      </v-timeline-item>

      <v-timeline-item small v-if="getApplicantStatus >= 1" hide-dot>
        <v-list dense>
          <v-list-group
            v-for="a in app.Applicants"
            v-bind:key="a.ApplicantID"
            :value="isCurrentApplicant(a.ApplicantID)"
            :ripple="false"
            append-icon=""
            :disabled="a.Disabled == true"
          >
            <template v-slot:activator>
              <table width="100%">
                <tr>
                  <td>
                    <div class="text-truncate" style="width:138px;float:left;">{{ a.FirstName }} {{ a.LastName }}</div>
                  </td>
                  <td with="25">
                    <a v-if="a.Deletable == true" @click.stop.prevent="deleteApplicant(a.ApplicantID)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                </tr>
              </table>
            </template>

            <!-- Identification -->
            <v-list-item
              
              link
              class="optFont"
              @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/identification')"
            >
              <v-list-item-icon class="listicon">
                <v-icon v-if="getApplicantIdentificationStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                <v-icon v-else size="14" color="primary">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.PersonalDetails") }}</v-list-item-content>
            </v-list-item>

            <!-- Address -->
            <div>
              <v-list-item   class="optFont" v-if="getApplicantAddressStatus(a.ApplicantID) == 1">
                <v-list-item-icon class="listicon">
                  <v-icon size="14" color="gray">fas fa-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ $t("labels.AddressHistory") }}</v-list-item-content>
              </v-list-item>

              <v-list-item
              
                link
                class="optFont"
                v-else
                @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/address')"
              >
                <v-list-item-icon class="listicon">
                  <v-icon v-if="getApplicantAddressStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                  <v-icon v-if="getApplicantAddressStatus(a.ApplicantID) == 2" size="14" color="primary">fas fa-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ $t("labels.AddressHistory") }}</v-list-item-content>
              </v-list-item>
            </div>
            <!-- Income -->
            <v-list-item   class="optFont" v-if="getApplicantIncomeStatus(a.ApplicantID) == 1 && app.showIncome == true">
              <v-list-item-icon class="listicon">
                <v-icon size="14" color="gray">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Income") }}</v-list-item-content>
            </v-list-item>

            <v-list-item
             
              link
              class="optFont"
              v-else-if="app.showIncome == true"
              @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/income')"
            >
              <v-list-item-icon class="listicon">
                <v-icon v-if="getApplicantIncomeStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                <v-icon v-if="getApplicantIncomeStatus(a.ApplicantID) == 2" size="14" color="primary">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Income") }}</v-list-item-content>
            </v-list-item>

            <!-- Property -->
            <v-list-item   class="optFont" v-if="getApplicantPropertyStatus(a.ApplicantID) == 1 && app.showProperty == true">
              <v-list-item-icon class="listicon">
                <v-icon size="14" color="gray">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.PropertiesOwned") }}</v-list-item-content>
            </v-list-item>

            <v-list-item
             
              link
              class="optFont"
               v-else-if="app.showProperty == true"
              @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/property')"
            >
              <v-list-item-icon class="listicon">
                <v-icon v-if="getApplicantPropertyStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                <v-icon v-if="getApplicantPropertyStatus(a.ApplicantID) == 2" size="14" color="primary">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.PropertiesOwned") }}</v-list-item-content>
            </v-list-item>

            <!-- Assets -->
            <v-list-item class="optFont" v-if="getApplicantAssetStatus(a.ApplicantID) == 1 && app.showAssets == true">
              <v-list-item-icon class="listicon">
                <v-icon size="14" color="gray">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Assets") }}</v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              class="optFont"
            v-else-if="app.showAssets == true"
              @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/asset')"
            >
              <v-list-item-icon class="listicon">
                <v-icon v-if="getApplicantAssetStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                <v-icon v-if="getApplicantAssetStatus(a.ApplicantID) == 2" size="14" color="primary">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Assets") }}</v-list-item-content>
            </v-list-item>
            <!-- Liabilities -->
            <v-list-item class="optFont" v-if="getApplicantLiabilitiesStatus(a.ApplicantID) == 1 && app.showLiabilities == true">
              <v-list-item-icon class="listicon">
                <v-icon size="14" color="gray">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Liabilities") }}</v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              class="optFont"
            v-else-if="app.showLiabilities == true"
              @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/' + a.ApplicantID + '/liability')"
            >
              <v-list-item-icon class="listicon">
                <v-icon v-if="getApplicantLiabilitiesStatus(a.ApplicantID) == 3" size="14" color="green">far fa-check-circle</v-icon>
                <v-icon v-if="getApplicantLiabilitiesStatus(a.ApplicantID) == 2" size="14" color="primary">fas fa-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t("labels.Liabilities") }}</v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-if="app.AddCoApplicant == true" link class="optFont2" @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/addCoApplicantV2')">
            <v-list-item-icon class="listicon">
              <v-icon size="16">fas fa-plus-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ $t("labels.AddCoApplicant") }}</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-timeline-item>


<!-- Mortgage Request -->
      <v-timeline-item v-if="getMortgageStatus == 0 && app.DisplayMortgage == true" small color="grey lighten-1">
        <v-list>
          <v-list-item link disabled>{{ $t("labels.MortgageRequest") }}</v-list-item>
        </v-list>
      </v-timeline-item>

      <v-timeline-item v-if="getMortgageStatus == 1 && app.DisplayMortgage == true" small color="primary">
        <v-list>
          <v-list-item
            link
            @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/mortgage')"
            >{{ $t("labels.MortgageRequest") }}</v-list-item
          >
        </v-list>
      </v-timeline-item>

      <v-timeline-item v-if="getMortgageStatus == 2 && app.DisplayMortgage == true" small :icon="'far fa-check-circle'" color="green" icon-color="white" :fill-dot="true">
        <v-list>
          <v-list-item
            link
            @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/mortgage')"
            >{{ $t("labels.MortgageRequest") }}</v-list-item
          >
        </v-list>
      </v-timeline-item>







      <v-timeline-item v-if="getSummaryStatus==0" small color="grey lighten-1">
        <v-list>
          <v-list-item link disabled>{{$t('labels.ReviewAndSubmit')}}</v-list-item>
        </v-list>
      </v-timeline-item>
      <v-timeline-item v-if="getSummaryStatus == 1" small color="primary">
        <v-list>                               
           <v-list-item
            link
            @click="$router.push('/' + siteID + '/InviteCoApplicant/' + mortgageApplicationID + '/' + guid + '/applicant/summary')"
            >{{ $t("labels.ReviewAndSubmit") }}</v-list-item
          >                
        </v-list>
      </v-timeline-item>



      
    </v-timeline>
     <!-- <v-footer v-if="showFlag" class="justify-center pl-0" inset app>
      <v-btn color="primary" @click="openmain">Main Menu</v-btn>
    </v-footer>  -->
  </v-navigation-drawer>
</template>

<script>
import { EventBus } from "@/services/eventBus";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
export default {
  props: ["app"],
  data() {
    return {
      showFlag: false,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      guid: this.$route.params.guid,
      userID: localStorageSvc.getUser(),
      applicantID:null,
      // InvitedApplicant: this.$route.params.applicantid,
      drawerStatus: {
        flag: false,
        permanent: true,
        watchResizeFlag: true
      }
    };
  },
  computed: {
    // 0: in-active, 1:current, 2:completed
    getInterViewStatus() {
      //let path = this.$route.path;
      if (this.app.MortgageApplicationID > 0) return 2;
      else return 1;
    },
    getApplicantStatus() {
      if (this.app.Step > 1) return 2;
      if (this.app.Step == 1) return 1;
      return 0;

       
    },
    getMortgageStatus() {      
      if (this.app.Step > 2) return 2;
      if (this.app.Step == 2) return 1;
      return 0;
    },
    getSummaryStatus(){ 
       if((this.app.ReqIncome && this.app.Applicants[0].Incomes.length == 0) || (this.app.ReqAssets && this.app.Applicants[0].Assets.length == 0)){
         return 0;
       }else{
           if(this.app.Step>=3) return 1;
           return 0;
       }
     
    }

  },
  methods: {
     openmain(){
      this.drawerStatus.flag = false;
       EventBus.$emit("opendrawer");
    },
    isCurrentApplicant(applicantID) {
      let path = this.$route.path;
      let strApplicantID = applicantID + "";
      if (path.indexOf(strApplicantID) > 0) return true;
      else return false;
    },
    getApplicantCurrentStep(applicantID) {
      let path = this.$route.path;
      let strApplicantID = applicantID + "";
      if (path.indexOf(strApplicantID) > 0) {
        if (path.indexOf("identification") > 0) return 1;
        if (path.indexOf("address") > 0) return 2;
        if (path.indexOf("income") > 0) return 3;
        if (path.indexOf("property") > 0) return 4;
        if (path.indexOf("asset") > 0) return 5;
        if (path.indexOf("liability") > 0) return 6;
      }
      return -1;
    },
    getApplicantStep(applicantID) {
      for (let i = 0; i < this.app.Applicants.length; i++) {
        let a = this.app.Applicants[i];
        if (a.ApplicantID == applicantID) {
          return a.Step;
        }
      }
      return -1;
    },
    deleteApplicant(applicantID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmRemoveCoApplicant"),
        () => {
          let postData = {
            ApplicantID: applicantID,
            MortgageApplicationID: this.mortgageApplicationID,
            SiteID: this.siteID,
            guid: this.guid
          };
          dataSvc
            .getHttp()
            .post("/api/MTGAppRemoveCoApplicantInvite", postData)
            .then(res => {
                 let mainApplicantID = res.data.MainApplicantID;
                this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + mainApplicantID + "/identification");
              
            });
        },
        () => {}
      );
    },

    getApplicantIdentificationStatus(applicantID) {
      let step = this.getApplicantStep(applicantID);
      if (step >= 1) return 3;
      return 1;
    },
    getApplicantAddressStatus(applicantID) {
      let step = this.getApplicantStep(applicantID);
      if (step >= 2) return 3;
      if (step >= 1) return 2;
      if (this.getApplicantCurrentStep(applicantID) == 2) return 2;
      return 1;
    },
    getApplicantIncomeStatus(applicantID) {          
      let step = this.getApplicantStep(applicantID);
      if (step >= 3) return 3;
      if (step >= 2) return 2;
      if (this.getApplicantCurrentStep(applicantID) == 3) return 2;
      return 1;
    },
    getApplicantPropertyStatus(applicantID) {
      let step = this.getApplicantStep(applicantID);
      if (step >= 4) return 3;
      if (step >= 3) return 2;
      if (this.getApplicantCurrentStep(applicantID) == 4) return 2;
      return 1;
    },
    getApplicantAssetStatus(applicantID) {
      let step = this.getApplicantStep(applicantID);
      if (step >= 5) return 3;
      if (step >= 4) return 2;
      if (this.getApplicantCurrentStep(applicantID) == 5) return 2;
      return 1;
    },
     getApplicantLiabilitiesStatus(applicantID) {
      let step = this.getApplicantStep(applicantID);
      if (step >= 6) return 3;
      if (step >= 5) return 2;
      if (this.getApplicantCurrentStep(applicantID) == 6) return 2;
      return 1;
    },

    onStatus(isOpen) {
      EventBus.$emit("drawStatusChange", isOpen);
    },
    onResize() {
      if (!this.drawerStatus.watchResizeFlag) return;
      let w = window.innerWidth;
      if (w <= 500) {
        this.showFlag = true;
        this.drawerStatus.flag = false;
        this.drawerStatus.permanent = false;
      } else {
        this.showFlag = false;
        this.drawerStatus.flag = true;
        this.drawerStatus.permanent = true;
      }
    },
    openDrawer() {
      this.drawerStatus.flag = true;
      this.drawerStatus.permanent = false;
      this.drawerStatus.watchResizeFlag = false;
      setTimeout(() => {
        this.drawerStatus.watchResizeFlag = true;
      }, 1000);
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.onResize();
    });
    this.onResize();
    EventBus.$on("openside", () => {
      this.openDrawer();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize());
    EventBus.$off("openside");
  }
};
</script>

<style scoped>
.v-list {
  padding: 0 !important;
  margin-left: -30px;
}
.v-timeline-item {
  padding-bottom: 0 !important;
}
.v-list-item__icon:first-child {
  margin-right: 0 !important;
}
</style>
